import {ChangeDetectionStrategy, Component, Inject, OnInit} from '@angular/core';
import {MatCheckboxChange} from '@angular/material/checkbox';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {BehaviorSubject} from 'rxjs';
import {take} from 'rxjs/operators';

import TermType from '../../enums/TermsTypes.enum';
import {StorageService} from '../../../services/storage.service';
import {UserService} from '../../../services/shared/user.service';
import {ErrorMatcher, ErrorType} from '../../errors/ErrorMatcher';

export class ApproveTermsAndConditionsParams {
  constructor(
    public termsToApprove: TermType[]
  ) {
  }
}

@Component({
  selector: 'terra-approve-terms-and-conditions-dialog',
  templateUrl: './approve-terms-and-conditions-dialog.component.html',
  styleUrls: ['./approve-terms-and-conditions-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class ApproveTermsAndConditionsDialogComponent implements OnInit {
  approvedByUser$ = new BehaviorSubject<boolean>(false);
  termType = TermType;

  constructor(
    private dialogRef: MatDialogRef<ApproveTermsAndConditionsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ApproveTermsAndConditionsParams,
    private storageService: StorageService,
    private userService: UserService,
  ) {
  }

  ngOnInit(): void {
  }

  onChange(event: MatCheckboxChange) {
    this.approvedByUser$.next(event.checked);
  }

  approve() {
    this.userService.updateTermsAndConditions().pipe(
      take(1)
    ).subscribe(_ => {
      this.completeTermsUpdate();
    }, error => {
      if (ErrorMatcher.isError(error, ErrorType.preconditionFailed)) {
        this.completeTermsUpdate();
        this.storageService.setTermsApproveRetry();
      }
    });
  }

  private completeTermsUpdate() {
    this.storageService.removeTermsData();
    this.dialogRef.close(true);
  }
}
